<div class="reset-screen">
  <div class="guide">
    <kp-reflect-animation [skipIntro]="true" [canvasHeight]="110"></kp-reflect-animation>
  </div>

  <kp-modal
    *ngIf="showEmailVerificationModal"
    [isOpen]="showEmailVerificationModal"
    (isOpenChange)="isEmailVerificationModalOpen()"
    type="info">
    <kp-modal-email-verification-required
      [email]="email.value"
      (closeClicked)="showEmailVerificationModal = false"></kp-modal-email-verification-required>
  </kp-modal>

  <div class="reset">
    <h1 class="main-title">Reset Your Password</h1>
    <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
      <label>
        <span class="form_label">Email</span>
        <input name="email" type="email" placeholder="email@example.com" required [formControl]="email" />
      </label>
      <div class="button-wrap">
        <button class="button button-pill" [disabled]="disableSubmitButton || !emailForm.valid" type="submit">
          Send Reset Code
        </button>
      </div>
    </form>
  </div>
</div>
